<template>
  <div :class="isFixedTab ? '' : $style.box">
    <van-tabs :class="$style.tabs" v-model="activeTabValue" @change="changeActiveTab">
      <van-tab
        v-for="(item, index) in tabModel"
        :key="index"
        :title="item.title"
        :name="item.name"
      ></van-tab>
    </van-tabs>
    <div :class="$style.search" @click="search">
      <van-icon name="search" :class="$style.icon" />
    </div>
    <div :class="$style['sort-type']" @click="toggleSortType">
      <span v-if="activeTabValue == 'is_new'">{{ sortType == 1 ? '发帖时间' : '更新时间' }}</span>
    </div>
  </div>
</template>

<script>
import { Tabs, Tab, Icon } from 'vant';
export default {
  components: {
    VanTabs: Tabs,
    VanTab: Tab,
    VanIcon: Icon,
  },
  props: {
    isFixedTab: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeTabValue: 'is_new',
      tabModel: [
        {
          title: '最新',
          name: 'is_new',
        },
        {
          title: '最热',
          name: 'is_hot',
        },
        {
          title: '精华',
          name: 'is_essence',
        },
      ],
      sortType: 0, // 1：按发帖时间倒叙（1）； 2：按更新时间倒叙（0） // 默认按更新时间倒叙
    };
  },
  created() {
    this.activeTabValue = localStorage.getItem('tabValue') || 'is_new';
    this.sortType = localStorage.getItem('sortType') || 0;
  },
  activated() {
    // 当不是首次进入页面，且不是从详情页返回的时候初始化并获取数据
    if (!this.$route.meta.isBack && !this.isFirstEnter) {
      this.activeTabValue = 'is_new';
      this.sortType = 0;
    }
  },
  methods: {
    changeActiveTab(activeTabValue) {
      this.$emit('changeActiveTab', activeTabValue);
      localStorage.setItem('tabValue', this.activeTabValue);
    },
    toggleSortType() {
      this.sortType = localStorage.getItem('sortType') == 1 ? 0 : 1;
      this.$emit('changeSortType', this.sortType);
      localStorage.setItem('sortType', this.sortType);
    },
    search() {
      this.$emit('search');
    },
  },
};
</script>

<style lang='scss' module>
@import '~@/styles/mixins.scss';
.box {
  width: 100%;
  height: 44px;
  overflow: hidden;
  border-bottom: 1px solid#ececec;
  background: #fff;
}
.tabs {
  width: 60%;
  height: 44px;
  position: absolute;
  background: #fff;
  :global {
    .van-tabs__wrap {
      height: 43px;
    }
  }
}
.sort-type {
  position: absolute;
  right: 0px;
  width: 80px;
  height: 44px;
  padding-right: 20px;
  text-align: right;
  line-height: 44px;
  background: #fff;
  font-size: 14px;
  color: #2797ff;
}
.search {
  width: 30px;
  height: 44px;
  position: absolute;
  right: 84px;
  padding: 10px 0px 0px 0px;
  margin-right: 20px;
  background-color: #fff;
  .icon {
    font-size: 22px;
  }
}
</style>